import login from './login.json'
import register from './register.json'

export default { login, register }